import { store } from '../../../../../resources/frontend/js/store/index';
import { sherlockCheck } from '@form/utils/lead-services/sherlock';
import { elmoCheck } from '@form/utils/lead-services/elmo';
import { usePage } from '@inertiajs/vue3';
import { submitForm } from '@form/utils/submit';
import { partialElmoCheck } from '@form/utils/lead-services/partial-elmo';

export const sendLead = body => {
    const page = usePage();

    fetch(window.location.href.replace(`/${page.props.localizedThankyou}`, ''), {
        method: 'post',
        body,
    })
        .then(response => response.json())
        .then(data => {
            if (data.sendingLeadFailed === true) {
                leadIsSent(null, false);
                return;
            }

            if (Object.keys(data).length === 2 && data.success !== undefined && data.sendingLeadFailed !== undefined) {
                submitForm();
                return;
            }

            if (store.state.page.productType === 'marketplaces' || store.state.page.leadService === 'sherlock') {
                sherlockCheck(data);
                return;
            }

            if (data.response.url) {
                partialElmoCheck(data);
                return;
            }

            elmoCheck(data);
        }).catch(() => {
            alert('Something went wrong, please try again. (2)');
            store.commit('form/setAttribute', {
                key: 'loading',
                value: false,
            });
        });
};

export const leadIsSent = (eventId, leadSuccess = true, smsVerification = null) => {
    const page = usePage();

    store.commit('form/addField', { name: 'lead_success', data: { name: 'lead_success' } });
    store.commit('form/setFieldData', { name: 'lead_success', key: 'value', value: leadSuccess ? '1' : '0' });

    if (eventId) {
        store.commit('form/addField', { name: 'eventId', data: { name: 'eventId' } });
        store.commit('form/setFieldData', { name: 'eventId', key: 'value', value: eventId });
    }

    if (smsVerification && page.props.sms_verification?.method === 'code') {
        store.state.form.smsVerification.hash = smsVerification.hash;
        store.state.form.smsVerification.phone = smsVerification.phone;
        store.state.form.state = 'smsVerification';
        return;
    }

    submitForm();
};
